export default __webpack_public_path__ + "static/media/nineteen.512f66e8.png";